import { Injectable } from '@angular/core';

// Abstracts
import { NgParamService } from '../abstracts';

@Injectable()
export class ParamService implements NgParamService {

    private params: { [key: string]: any } = { };

    private makeId(length: number): string {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    public get(id: string | number): any {
        const paramId = id.toString();
        if (this.params[paramId]) {
            const param = new Object(this.params[paramId]);
            delete this.params[paramId];
            return param;
        } else {
            return null;
        }
    }

    public set(param: any, id?: string | number): string {
        const paramId = id ? id.toString() : this.makeId(6);
        this.params[paramId] = param;
        return paramId;
    }

}
